module.exports = __webpack_public_path__ + "media/pages/youthhome-6b7f8618.jpg";